import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicSodiumPotassiumDiagramContent } from "./CardiometabolicSodiumPotassiumDiagram";
import { CardiometabolicSodiumPotassiumKeyContent } from "./CardiometabolicSodiumPotassiumKey";

const SvgCardiometabolicSodiumPotassiumDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1284, 1500)}
      viewBox={diagramOnly ? "0 142 1024 1284" : "0 0 1024 1500"}
    >
      <g id="cardiometabolic-sodiumpotassium-diagram+key" clipPath="url(#clip0_18293_231782)">
        <rect width={1024} height={diagramOnly ? 1284 : 1500} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicSodiumPotassiumKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicSodiumPotassiumDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_231782">
          <rect width={1024} height={1500} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_231782">
          <rect width={1024} height={1284} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicSodiumPotassiumDiagramKey;
